module.exports = __webpack_public_path__ + "static/media/replace-vehicle-blue.ec354b63.svg";